/* =============================================================================
 * Copyright (c) 2026 SKYXOPS Corp. All rights reserved.
 * ============================================================================= */
/**
 * Pre-paint theme restore (AI-LAUNCH-43, extracted for test in AI-LAUNCH-51).
 *
 * Applied before React mounts so themed surfaces — notably the pre-auth login
 * page, which has no ThemeToggle — render in the right mode with no flash.
 *
 * Default is LIGHT: dark applies only when the user explicitly opted in. We
 * deliberately do NOT follow the OS prefers-color-scheme here, so the product is
 * light by default regardless of the system setting.
 *
 * This used to live inline in main.tsx and read localStorage 'skyxops-theme-v2',
 * a key nothing ever writes, so the restore could never fire and dark-mode users
 * always got a light first paint. The preference is owned by @skyxops/ui under
 * 'skyxops-theme'; read it through the library rather than re-spelling the key.
 *
 * It lives in its own module so the behaviour is testable — main.tsx cannot be
 * imported in a test, since importing it mounts the entire app.
 */
import { storedThemePreference } from '@skyxops/ui';

/** Whether the first paint should be dark. */
export function bootWantsDark(): boolean {
  return storedThemePreference() === 'dark';
}

/** Apply the stored preference to <html> before first paint. */
export function applyBootTheme(): void {
  document.documentElement.classList.toggle('dark', bootWantsDark());
}
